import Image from "next/image";

export const IphoneMockup = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='relative z-0 w-full max-w-[326px]'>
      <div className='rounded absolute bottom-[2.5%] left-[5.5%] right-[5.5%] top-[2.3%] overflow-hidden rounded-[6px] bg-[#fff]'>
        {children}
      </div>
      <Image
        alt='ElevenLabs Reader App'
        className='pointer-events-none relative z-50 max-w-full'
        height={661}
        src='https://storage.googleapis.com/eleven-public-cdn/images/marketing/iphone-mockup.png'
        width={326}
      />
    </div>
  );
};
